import React from 'react';
import { Text, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useI18n } from '@shared/i18n/useI18n';
import type { TDocumentsHeaderProps } from '../../types';
import { DocumentsMonthFilter } from './DocumentsMonthFilter';
import { DocumentsTabs } from './DocumentsTabs';

export const DocumentsHeader = ({
    activeTab,
    onTabChange,
    monthOptions,
    selectedMonths,
    onToggleMonth,
    onClearMonths,
}: TDocumentsHeaderProps) => {
    const { t } = useI18n();
    const insets = useSafeAreaInsets();

    return (
        <View className="bg-white px-md pb-xs" style={{ paddingTop: insets.top }}>
            <Text className="mb-lg mt-md text-xl font-bold text-black">{t('documents.title')}</Text>
            <DocumentsTabs activeTab={activeTab} onTabChange={onTabChange} />
            <DocumentsMonthFilter
                options={monthOptions}
                selectedMonths={selectedMonths}
                onToggleMonth={onToggleMonth}
                onClearMonths={onClearMonths}
            />
        </View>
    );
};
